/* Shared init for the carousel_2 section (extracted from its former inline script).
   The section can render multiple times per page; every instance emits this same
   deferred script tag, so the whole body is guarded to execute once. Each slider
   instance is initialized individually (slick-initialized guard). */
if (!window.__carousel2InitDone) {
  window.__carousel2InitDone = true;

  $(document).ready(function () {
    // One slick init per carousel_2 instance
    $('.hp_carousel .gen_carousel').each(function () {
      var $el = $(this);
      if ($el.hasClass('slick-initialized')) return;
      $el.slick({
        dots: false,
        infinite: false,
        speed: 600,
        touchThreshold: 100,
        waitForAnimate: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1215,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
              touchThreshold: 10,
              waitForAnimate: false,
            }
          },
          {
            breakpoint: 995,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              touchThreshold: 10,
              waitForAnimate: false
            }
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              touchThreshold: 10,
              waitForAnimate: false
            }
          }
        ]
      });
    });

    // Yotpo review-text rewrite moved to shared assets/yotpo-review-text.js (C6).
  });
}
